import { RText } from './RText';
import { resolveNoContainer } from './resolve-no-container';
import { resolveRendersOwnElement } from './resolve-renders-own-element';
import { defaultAttributeValues } from './default-attribute-values';
import { attributeEditModeConfigs } from './attribute-edit-mode-configs';
import type {
  DisplayCardEntry,
  PageViewType,
  WidgetInstanceProps,
} from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';

export const displayCardEntry: DisplayCardEntry = {
  id: ComponentIdentifiers.rText,
  resolveNoContainer,
  resolveRendersOwnElement,
  card: ({
    componentAttributes,
    styleProps,
    className,
    widgetInstanceProps,
    pageViewType,
  }: {
    componentAttributes?: { [key: string]: any };
    styleProps?: { [key: string]: any };
    className?: string;
    widgetInstanceProps?: WidgetInstanceProps;
    pageViewType?: PageViewType;
  }) => (
    <RText
      componentAttributes={componentAttributes}
      styleProps={styleProps}
      className={className}
      widgetInstanceProps={widgetInstanceProps}
      pageViewType={pageViewType}
    />
  ),
  defaultAttributeValues,
  attributeEditModeConfigs,
};
